import type { NumberPathConfig } from './NumberPathConfig.js';

export type NumberPathMoveResult = 'accepted' | 'overshoot' | 'full' | 'complete';

export class NumberPathState {
  private readonly pathValues: number[];
  private readonly pathJumps: number[] = [];

  constructor(readonly config: NumberPathConfig) {
    this.pathValues = [config.start];
  }

  get value() { return this.pathValues[this.pathValues.length - 1]; }
  get values() { return [...this.pathValues]; }
  get jumps() { return [...this.pathJumps]; }
  get movesUsed() { return this.pathJumps.length; }
  get movesRemaining() { return this.config.maxJumps - this.movesUsed; }
  get isComplete() { return this.value === this.config.target; }
  get isFull() { return this.movesUsed >= this.config.maxJumps; }

  addJump(jump: number): NumberPathMoveResult {
    if (!this.config.jumps.includes(jump)) return 'full';
    if (this.isComplete) return 'complete';
    if (this.isFull) return 'full';
    const next = this.value + jump;
    if (next > this.config.target) return 'overshoot';
    this.pathJumps.push(jump);
    this.pathValues.push(next);
    return next === this.config.target ? 'complete' : 'accepted';
  }

  undo() {
    if (this.pathJumps.length === 0 || this.isComplete) return false;
    this.pathJumps.pop();
    this.pathValues.pop();
    return true;
  }

  reset() {
    if (this.pathJumps.length === 0) return false;
    this.pathJumps.length = 0;
    this.pathValues.length = 1;
    return true;
  }
}
